<form [formGroup]="addPayPalPaymentMethodForm">

        <lib-banner [kind]="StatusKind.Warning"  [isDismissable]="false">
            <ng-container text i18n="@@CommonPayPalProNoLongerSupporterBannerText">
                Credit card entry for PayPal Pro is no longer supported. The PayPal integration must be updated through the Business Settings page.
            </ng-container>
        </lib-banner>

        <lib-input-select data-clarity-mask="true"
            [formControl]="addPayPalPaymentMethodForm.controls.CardType"
            [errorMessages]="cardTypeError"
            [layout]="FormFieldLayout.Half"
            placeholderText="Select..."
            i18n-placeholderText="@@CommonSelectPlaceholder"
            [qaTag]="'input-paypalpro-cardtype'"
            (change)="CardTypeChanged($event!)">
            <ng-container label
                i18n="@@CommonAddPaymentSourceCreditCardTypeLabel">
                Card Type
            </ng-container>

            <lib-input-select-item *ngFor="let type of creditCardTypes" data-clarity-mask="true"
                [value]="type">
                {{ type.Name }}
            </lib-input-select-item>
        </lib-input-select>

        <lib-input-text data-clarity-mask="true"
            [formControl]="addPayPalPaymentMethodForm.controls.AccountNumber"
            inputFilter="[-., 0-9]"
             [layout]="FormFieldLayout.Half"
            [errorMessages]="cardNumberError"
            [qaTag]="'input-paypalpro-cardnumber'">
            <ng-container label
                i18n="@@CommonAddPaymentSourceCreditCardNumberLabel">
                Card Number
            </ng-container>
        </lib-input-text>



        <lib-input-text data-clarity-mask="true"
            [formControl]="addPayPalPaymentMethodForm.controls.HolderName"
            [errorMessages]="cardHolderError"
            [qaTag]="'input-paypalpro-cardholdername'">
            <ng-container label
                i18n="@@CommonAddPaymentSourceCreditCardHolderNameLabel">
                Card Holder Name
            </ng-container>
        </lib-input-text>



        <lib-input-month-year data-clarity-mask="true"
            [formControl]="addPayPalPaymentMethodForm.controls.ExpiryDate"
            [minDate]="minDate"
            [maxDate]="maxDate"
             [layout]="FormFieldLayout.Half"
            [errorMessages]="cardExpiryDateError"
            [qaTag]="'input-paypalpro-expirydate'">
            <ng-container label
                i18n="@@CommonAddPaymentSourceCreditCardExpiryDateLabel">
                Expiry Date
            </ng-container>
        </lib-input-month-year>

        <lib-input-text data-clarity-mask="true"
            [formControl]="addPayPalPaymentMethodForm.controls.CVV"
            inputFilter="[0-9]"
             [layout]="FormFieldLayout.Half"
            [placeholderText]="cvvPlaceholder"
            [errorMessages]="cardCVVError"
            [qaTag]="'input-paypalpro-cvv'">
            <ng-container label
                i18n="@@CommonAddPaymentSourceCreditCardCVVLabel">
                CVV
            </ng-container>
            <ng-container menu>
                <lib-icon
                    [icon]="Icon.Common.Help"
                    [size]="IconSize.ThreeExtraSmall"
                    [matTooltip]="cvvTooltip">
                </lib-icon>
            </ng-container>
        </lib-input-text>



        <lib-input-select
            [formControl]="addPayPalPaymentMethodForm.controls.Country"
            [qaTag]="'input-paypalpro-country'"
             [layout]="FormFieldLayout.Half"
            (change)="GetStates($event!)">
            <ng-container label
                i18n="@@CommonAddPaymentSourceCountryLabel">
                Country
            </ng-container>

            <lib-input-select-item *ngFor="let country of countries"
                [value]="country">
                {{ country.Name }}
            </lib-input-select-item>
        </lib-input-select>

        <lib-input-select
            [formControl]="addPayPalPaymentMethodForm.controls.State"
            placeholderText="Select..."
            i18n-placeholderText="@@CommonSelectPlaceholder"
            [errorMessages]="stateError"
            [qaTag]="'input-paypalpro-stateprovince'"
             [layout]="FormFieldLayout.Half">
            <ng-container label
                i18n="@@CommonAddPaymentSourceCreditCardStateProvinceLabel">
                State/Province
            </ng-container>

            <lib-input-select-item *ngFor="let state of states"
                [value]="state">
                {{ state.Name }}
            </lib-input-select-item>
        </lib-input-select>



        <lib-input-text data-clarity-mask="true"
            [formControl]="addPayPalPaymentMethodForm.controls.City"
            [errorMessages]="cityError"
             [layout]="FormFieldLayout.Half"
            [qaTag]="'input-paypalpro-city'">
            <ng-container label
                i18n="@@CommonAddPaymentSourceCreditCardCityLabel">
                City
            </ng-container>
        </lib-input-text>

        <lib-input-text data-clarity-mask="true"
            [formControl]="addPayPalPaymentMethodForm.controls.ZipCode"
            [errorMessages]="zipCodeError"
            [qaTag]="'input-paypalpro-zippostalcode'"
            [layout]="FormFieldLayout.Half">
            <ng-container label
                i18n="@@CommonAddPaymentSourceCreditCardZipCodeLabel">
                Zip/Postal Code
            </ng-container>
        </lib-input-text>
  


        <lib-input-text data-clarity-mask="true"
            [formControl]="addPayPalPaymentMethodForm.controls.Address1"
            [errorMessages]="addressError"
            [qaTag]="'input-paypalpro-addressline1'">
            <ng-container label
                i18n="@@CommonAddPaymentSourceCreditCardAddressLine1Label">
                Address Line 1
            </ng-container>
        </lib-input-text>
  

   
        <lib-input-text data-clarity-mask="true"
            [formControl]="addPayPalPaymentMethodForm.controls.Address2"
            [qaTag]="'input-paypalpro-addressline2'">
            <ng-container label
                i18n="@@CommonAddPaymentSourceCreditCardAddressLine2Label">
                Address Line 2
            </ng-container>
        </lib-input-text>
  

    @if (Scope.context != PaymentContext.SignupWidget && Scope.mode === PaymentSourceMode.Payment) {

            <lib-checkbox
                [formControl]="addPayPalPaymentMethodForm.controls.SavePaymentSource"
                (change)="SavePaymentMethodForFuture($event)"
                [qaTag]="'save-payment-method-for-future-use-checkbox'">
                <ng-container
                    i18n="@@CommonAddPaymentSourceSavePaymentSourceLabel">
                    Save this payment method for future use
                </ng-container>
            </lib-checkbox>
    
    }

    @if (Scope.context != PaymentContext.SignupWidget && (Scope.mode === PaymentSourceMode.Add || (Scope.mode === PaymentSourceMode.Payment && addPayPalPaymentMethodForm.controls.SavePaymentSource.value))) {

            <lib-checkbox
                [formControl]="addPayPalPaymentMethodForm.controls.AutoPay"
                [errorMessages]="autoPayError"
                [qaTag]="'checkbox-paypalpro-autopay'">
                <ng-container label
                    i18n="@@CommonAddPaymentSourceAutoPayLabel">
                    Auto Pay
                </ng-container>

                <ng-container i18n="@@CommonAddPaymentSourceAutoPayCheckboxDescription">
                    Automatically pay emailed invoices
                </ng-container>
            </lib-checkbox>
   
    }
</form>

@if (((Scope.context === PaymentContext.StudentPortal && Scope.mode === PaymentSourceMode.Add) || (Scope.context === PaymentContext.SignupWidget && Scope.mode === PaymentSourceMode.Payment)) && cardSurcharge && cardSurcharge.Type !== SurchargeType.None) {
    <div class="pb-2">
        <lib-label i18n="@@CommonNoteLabel">Note</lib-label>
        @if (cardSurcharge.Type === SurchargeType.Fixed) {
            <p i18n="@@CommonCreditCardFixedSurchargeText">
                A {{ cardSurcharge.Amount! | formatCurrency }} convenience fee will be applied to all credit card payments.
            </p>
        }
        @if (cardSurcharge.Type === SurchargeType.Percentage) {
            <p i18n="@@CommonCreditCardPercentageSurchargeText">
                A {{ cardSurcharge.Amount! | formatPercent: 2: 2 }} convenience fee will be applied to all credit card payments.
            </p>
        }
    </div>
}

@if (paymentProcessorError) {
    <lib-banner
        [isDismissable]="false"
        [mode]="BannerMode.Inline"
        [kind]="StatusKind.Danger">
        <ng-container text i18n="@@CommonPaymentSourceCreditCardPaymentProcessorError"> Credit card could not be processed. The payment processor returned the following message: <b>{{ paymentProcessorError }}</b>
        </ng-container>
    </lib-banner>
}